import React from 'react';

import { Button, Link } from 'components/ui';
import IconArrowNarrowRight from 'components/ui/icons/IconArrowNarrowRight';
import IconDiscount from 'components/ui/icons/IconDiscount';
import { TRANSLATIONS } from 'constants/translations';
import { cx } from 'helpers/StylingHelpers';
import { useTranslation } from 'hooks/common/useTranslation';
import { useAnalytics } from 'hooks/useAnalytics';

import type { IAccountPromotion } from 'types';

import styles from './AccountPromotionCard.module.scss';

interface Props {
  className?: string,
  promotion: IAccountPromotion
}

const AccountPromotionsCard = (props: Props) => {

  const { className, promotion } = props;
  const {
    dateLabel, title, description, url
  } = promotion || {};
  const { t } = useTranslation();
  const analytics = useAnalytics();

  const handleViewClick = () => {
    analytics.selectAccountPromotion(url);
  };

  return (
    <div
      className={cx(styles.root, className)}
      data-testid="account-promotions.card"
    >
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <IconDiscount className={styles.icon} />
        </div>
        <div className={styles.details}>
          <div
            className={styles.title}
            data-testid="account-promotions.card.title"
          >
            {title}
          </div>
          <div
            className={styles.date}
            data-testid="account-promotions.card.date"
          >
            {dateLabel}
          </div>
          <div
            className={styles.description}
            data-testid="account-promotions.card.description"
          >
            {description}
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        <Link
          href={url}
          legacyBehavior
          passHref
        >
          <Button
            tag="a"
            className={styles.detailsLink}
            onClick={handleViewClick}
            endIcon={IconArrowNarrowRight}
            endIconProps={{ className: styles.icon }}
            dataTestId="account-promotions.card.view-products-btn"
          >
            {t('PROMOTIONS.PROMOTION_VIEW_DETAILS', { ns: TRANSLATIONS.ACCOUNT })}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default AccountPromotionsCard;
